import { render, staticRenderFns } from "./RoleFilters.vue?vue&type=template&id=43c2f570&"
import script from "./RoleFilters.vue?vue&type=script&lang=js&"
export * from "./RoleFilters.vue?vue&type=script&lang=js&"
import style0 from "./RoleFilters.vue?vue&type=style&index=0&id=43c2f570&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports